import { basic, initSidebar, initTopbar } from './modules/layouts';
import { initLocaleDatetime, loadImg } from './modules/components';

loadImg();
initLocaleDatetime();
initSidebar();
initTopbar();
basic();
